import React from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { PiHandTapFill } from 'react-icons/pi'
import { TbCreditCardPay } from 'react-icons/tb'
import { RiListSettingsLine } from 'react-icons/ri'
import { TbListCheck } from 'react-icons/tb'
import useWindowDimensions from '../../_common/WindowDimesnions'
import defaultTexts from '../../../texts/texts'
import constants from '../../../config/constants'

const ProgressWrapper = (props) => {
  const { step } = props
  const theme = useTheme()
  const { width } = useWindowDimensions()

  const circleHeight = (width * 0.9) / 16
  const iconSize = width >= constants.xlBreakpoint ? 64 : 36
  const colorBlue = theme.palette.oxfordBlue
  const colorGray = theme.palette.grayX11

  const circleStyle = {
    flex: 1,
    height: `${circleHeight}px`,
    borderRadius: `${circleHeight/2}px`,
    border: '5px solid',
  }

  const lineStyle = {
    flex: 4,
    height: '5px',
  }

  const descriptionStyle = {
    flex: 1,
    fontSize: '18px',
    fontWeight: '500',
    maxWidth: '15%',
    textAlign: 'center',
  }

  return (
    <>
      {
        width >= constants.mdBreakpoint ?
        <>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
            sx={{ margin: '0px 4.5% 10px 4.5%' }}
          >
            <Box
              sx={{
                ...circleStyle,
                borderColor: colorBlue,
                color: colorBlue,
              }}
            >
              <Stack
                alignItems='center'
                justifyContent='center'
                sx={{ height: `${circleHeight - 10}px` }}
              >
                <PiHandTapFill size={iconSize} />
              </Stack>          
            </Box>
            <Box
              sx={{
                ...lineStyle,
                background: step > 1 ? colorBlue : colorGray,
              }}
            ></Box>
            <Box
              sx={{
                ...circleStyle,
                borderColor: step > 1 ? colorBlue : colorGray,
                color: step > 1 ? colorBlue : colorGray,
              }}
            >
              <Stack
                alignItems='center'
                justifyContent='center'
                sx={{ height: `${circleHeight - 10}px` }}
              >
                <TbCreditCardPay size={iconSize} />
              </Stack>          
            </Box>
            <Box
              sx={{
                ...lineStyle,
                background: step > 2 ? colorBlue : colorGray,
              }}
            ></Box>
            <Box
              sx={{
                ...circleStyle,
                borderColor: step > 2 ? colorBlue : colorGray,
                color: step > 2 ? colorBlue : colorGray,
              }}
            >
              <Stack
                alignItems='center'
                justifyContent='center'
                sx={{ height: `${circleHeight - 10}px` }}
              >
                <RiListSettingsLine size={iconSize} />
              </Stack>          
            </Box>
            <Box
              sx={{
                ...lineStyle,
                background: step > 3 ? colorBlue : colorGray,
              }}
            ></Box>
            <Box
              sx={{
                ...circleStyle,
                borderColor: step > 3 ? colorBlue : colorGray,
                color: step > 3 ? colorBlue : colorGray,
              }}
            >
              <Stack
                alignItems='center'
                justifyContent='center'
                sx={{ height: `${circleHeight - 10}px` }}
              >
                <TbListCheck size={iconSize} />
              </Stack>          
            </Box>
          </Stack>

          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
            sx={{ width: '100%' }}
          >
            <Box
              sx={{
                ...descriptionStyle,
                color: colorBlue,
              }}
            >
              {defaultTexts.selectSolutionText}
            </Box>
            <Box
              sx={{
                ...descriptionStyle,
                color: step > 1 ? colorBlue : colorGray,
              }}
            >
              {defaultTexts.selectSubscriptionText}
            </Box>
            <Box
              sx={{
                ...descriptionStyle,
                color: step > 2 ? colorBlue : colorGray,
              }}
            >
              {defaultTexts.configureParametersText}
            </Box>
            <Box
              sx={{
                ...descriptionStyle,
                color: step > 3 ? colorBlue : colorGray,
              }}
            >
              {defaultTexts.payAndSubmit}
            </Box>
          </Stack>
        </> :
        <>
          <Stack
            direction='column'
            alignItems='center'
            justifyContent='flex-start'
          >
            <Box
              sx={{
                ...circleStyle,
                borderColor: colorBlue,
                color: colorBlue,
                width: '60px',
                height: '60px',
                borderRadius: '30px',
                flex: null,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '20px',
              }}
            >
              { step === 1 && <PiHandTapFill size={iconSize} /> }
              { step === 2 && <TbCreditCardPay size={iconSize} /> }
              { step === 3 && <RiListSettingsLine size={iconSize} /> }
              { step === 4 && <TbListCheck size={iconSize} /> }
            </Box>
            <Box
              sx={{
                ...descriptionStyle,
                color: colorBlue,
                maxWidth: '80%',
                flex: null,
              }}
            >
              { step === 1 && defaultTexts.selectSolutionText }
              { step === 2 && defaultTexts.selectSubscriptionText }
              { step === 3 && defaultTexts.configureParametersText }
              { step === 4 && defaultTexts.payAndSubmit }
            </Box>
          </Stack>
        </>
      }
      
    </>
  )
}

export default ProgressWrapper